import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startOfDayInMilliseconds } from '@utils/date';
import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { TAssetAcquiredStatuses } from '@enums/asset';
import { defaultMeta } from '@enums/common';

import { endDateTypeOptions } from '@components/routes/AdminPanel/ManageAcquiredAssets/constants';

interface IInitialState extends TDefaultStoreDTO {
	assetTypeId: string | null;
	assetSubTypeId: string | null;
	assetOwnerId: string | null;
	rentStatus: TAssetAcquiredStatuses | null;
	datesOverlapType: string | null;
	fromDate: number | null;
	toDate: number | null;
	endDateType: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	searchValue: '',
	sortDirection: false,
	sortFieldName: null,
	assetTypeId: null,
	assetSubTypeId: null,
	assetOwnerId: null,
	rentStatus: null,
	datesOverlapType: null,
	fromDate: null,
	toDate: null,
	endDateType: endDateTypeOptions[0].value,
};

const manageAcquiredAssets = createSlice({
	name: 'manageAcquiredAssets',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setAssetTypeId: (state, action: PayloadAction<{ assetTypeId: string | null }>) => {
			state.assetTypeId = action.payload.assetTypeId;
			state.page = initialState.page;
		},
		setAssetSubTypeId: (state, action: PayloadAction<{ assetSubTypeId: string | null }>) => {
			state.assetSubTypeId = action.payload.assetSubTypeId;
			state.page = initialState.page;
		},
		setAssetOwnerId: (state, action: PayloadAction<{ assetOwnerId: string | null }>) => {
			state.assetOwnerId = action.payload.assetOwnerId;
			state.page = initialState.page;
		},
		setRentStatus: (state, action: PayloadAction<{ rentStatus: TAssetAcquiredStatuses | null }>) => {
			state.rentStatus = action.payload.rentStatus;
			state.page = initialState.page;
		},
		setDatesOverlapType: (state, action: PayloadAction<{ datesOverlapType: string | null }>) => {
			state.datesOverlapType = action.payload.datesOverlapType;
			state.page = initialState.page;
		},
		setEndDateType: (state, action: PayloadAction<{ endDateType: string | null }>) => {
			state.endDateType = action.payload.endDateType;
			state.page = initialState.page;
		},
		setFromDate: (
			state,
			action: PayloadAction<{ fromDate: number | null }>,
		) => {
			if (action.payload.fromDate) {
				state.fromDate = startOfDayInMilliseconds(action.payload.fromDate);
			} else state.fromDate = null;

			state.page = initialState.page;
		},
		setToDate: (
			state,
			action: PayloadAction<{ toDate: number | null }>,
		) => {
			if (action.payload.toDate) {
				state.toDate = startOfDayInMilliseconds(action.payload.toDate);
			} else state.toDate = null;

			state.page = initialState.page;
		},
		resetManageAcquiredAssetsTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
	setAssetTypeId,
	setAssetSubTypeId,
	setAssetOwnerId,
	setRentStatus,
	setDatesOverlapType,
	setEndDateType,
	setFromDate,
	setToDate,
} = manageAcquiredAssets.actions;

export default manageAcquiredAssets.reducer;
